import { cn } from '../cn';
import { IconButton } from './IconButton';

export interface StepperProps {
  value: number;
  min: number;
  max: number;
  onChange: (v: number) => void;
  format?: (v: number) => string;
  onRemove?: () => void;
  className?: string;
}

/** − value + (word boost ×1–×3): 24 px framed glyph buttons, mono 11px value, min-width 32; mobile 32 px. */
export function Stepper({ value, min, max, onChange, format, onRemove, className }: StepperProps) {
  return (
    <div className={cn('flex items-center gap-2 md:gap-1.5', className)}>
      <IconButton label="Decrease" size="sm" className="h-8 w-8 rounded-lg text-lg md:h-6 md:w-6 md:rounded md:text-base" disabled={value <= min} onClick={() => onChange(Math.max(min, value - 1))}>
        −
      </IconButton>
      <span className="min-w-[28px] text-center font-mono text-base font-medium text-fg2 md:min-w-[32px] md:text-sm">{format ? format(value) : value}</span>
      <IconButton label="Increase" size="sm" className="h-8 w-8 rounded-lg text-lg md:h-6 md:w-6 md:rounded md:text-base" disabled={value >= max} onClick={() => onChange(Math.min(max, value + 1))}>
        +
      </IconButton>
      {onRemove && (
        <IconButton framed={false} label="Remove" size="md" onClick={onRemove} className="pl-1.5 text-[18px] md:px-1 md:text-lg">
          ×
        </IconButton>
      )}
    </div>
  );
}
